import React from 'react';
import { roomColorStyle } from 'functions/roomColors';

// A link to a room in a message: the room's color dot and current name.
// Clicking it joins by id (react/netplay/netplayPageHandlers). The composer
// draws the same chip unlinked, so clicking it in a draft does nothing.
export default function RoomLinkChip({ roomId, name, colors = null, linked = true }) {
	if(!linked) {
		return <span className='room_link_chip' style={roomColorStyle(colors)}><span className='room_link_dot' aria-hidden='true' />{name}</span>;
	}
	const href = typeof siteUrl !== 'undefined' ? `${siteUrl}/netplay/${roomId}` : `/netplay/${roomId}`;
	return (
		<a
			className='chatlink room_link_chip'
			href={href}
			data-id={roomId}
			title={`Open ${name}`}
			style={roomColorStyle(colors)}
		><span className='room_link_dot' aria-hidden='true' />{name}</a>
	);
}
